// extracted by mini-css-extract-plugin
export default {"historical-view":"historical_historical-view__Iu1aS","tab-container":"historical_tab-container__WsS3H"};